import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import classnames from 'classnames';

import { formatUSD } from '@sparefoot/react-core/utils/format';

import { Group } from 'components/core/Page';
import { Text, Paragraph } from 'components/core/Typography';

import './YourStorageUnitCard.scss';

export function YourStorageUnitCard({ unit }) {
	return (
		<div className="card">
			<div className="card-header">
				<Text size="small">Your storage unit</Text>
			</div>
			<div className="card-block">
				<Group>
					<Paragraph
						size="small"
						last
					>
						Unit Type:
					</Paragraph>
					<Paragraph>
						{unit.size} {unit.typeText}
					</Paragraph>
				</Group>
				{!isEmpty(unit.availableAmenities) && (
					<Group>
						<Paragraph
							size="small"
							last
						>
							Features:
						</Paragraph>
						<Paragraph>
							{unit.availableAmenities.join(', ')}
						</Paragraph>
					</Group>
				)}
				{unit.special && (
					<Group>
						<Paragraph
							size="small"
							last
						>
							Specials:
						</Paragraph>
						<Paragraph
							size="small"
							className="specials"
						>
							{unit.special}
						</Paragraph>
					</Group>
				)}
				<div className="monthly-rent">
					<div className="rent">
						Monthly
						<br />
						Rent:
					</div>
					<div className="unit-price">
						{!!unit.quantity && unit.quantity <= 3 && (
							<Text
								color="red"
								size="tiny"
							>
								{unit.quantity} left at
							</Text>
						)}
						<Paragraph
							size="large"
							className={classnames('price sparefoot', {
								scarcity: !!unit.quantity && unit.quantity <= 3,
							})}
							last
						>
							{formatUSD(unit.price.meta)}
						</Paragraph>
						{unit.price.sparefoot !== 0 &&
							unit.price.sparefoot < unit.price.regular && (
								<div className="price regular">
									<Text className="label">
										Regular Price:{' '}
									</Text>
									<Text
										className="value"
										strikethrough
									>
										{formatUSD(unit.price.regular)}
									</Text>
								</div>
							)}
					</div>
				</div>
			</div>
		</div>
	);
}

YourStorageUnitCard.propTypes = {
	unit: PropTypes.object,
};

export default YourStorageUnitCard;
